//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import client from '~/graphql/queries/client.gql';

export default {
  props: {
    submitLabel: {
      type: String,
      default: 'Opdrachtgever aanmaken',
    },
  },
  apollo: {
    client: {
      query: client,
      variables() {
        return {
          uuid: this.$route.params.uuid,
        };
      },
      result(result) {
        this.formData = result.data.client;
      },
      skip() {
        return !this.$route.params?.uuid;
      },
    },
  },
  data() {
    return {
      formData: {},
    };
  },
};
